import { WebMercatorViewport } from '@deck.gl/core/typed';
import { Terminal } from 'ais-facade-api/api';
import styles from '../PortsTooltips/PortsTooltips.module.scss';
export const TerminalsTooltips = ({ terminals, viewState }: { terminals: Terminal[]; viewState: any }) => {
  const viewport = new WebMercatorViewport({ ...viewState });

  const tooltips = terminals.map((terminal: Terminal) => {
    if (typeof terminal.lat === 'number' && typeof terminal.lon === 'number') {
      const projection = viewport.project([terminal.lon, terminal.lat]);
      return (
        <div
          key={terminal.key}
          className={styles.tooltip}
          style={{
            left: projection[0],
            top: projection[1] + 8,
          }}
        >
          {terminal.code}
        </div>
      );
    }
  });
  return viewState.zoom >= 13 ? <>{tooltips}</> : null;
};
